import {
    FlashSVG,
    Typography,
    type TypographyVariant,
} from '@analytical-alley/ui';
import React, { ReactNode } from 'react';

interface Props {
    title: ReactNode;
    subtitle?: ReactNode | string;
    isLg?: boolean;
    tooltip?: ReactNode | string;
}

export const DashboardTitle = ({ title, subtitle, isLg = true, tooltip, }: Props) => {
    const titleVariant: TypographyVariant = isLg ? 'titleM' : 'bodyXL';

    return (
        <div className="inline-flex mx-4">
            <span className="mr-8">
                <FlashSVG />
            </span>

            {subtitle ? (
                <div className="flex flex-col gap-1 justify-start">
                    <Typography
                        variant={titleVariant}
                        tooltip={tooltip}
                        className="self-center"
                    >
                        {title}
                    </Typography>
                    {typeof subtitle === 'string' ? (
                        <Typography variant="bodyL" className="text-white/50">
                            {subtitle}
                        </Typography>
                    ) : (
                        subtitle
                    )}
                </div>
            ) : (
                <Typography
                    variant={titleVariant}
                    tooltip={tooltip}
                    className="self-center"
                >
                    {title}
                </Typography>
            )}
        </div>
    );
};
